import { Example } from "./Example";

import styles from "./Example.module.css";

import "../../assets/fonts/ArialNova/ArialNova.ttf";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    {
        text: "Can you summarize Ford OS Behaviors?",
        value: "Can you summarize Ford OS Behaviors?"
    },
    { text: "Can you share the details of leave policy?", value: "Can you share the details of leave policy?" },
    { text: "Can you share the details of performance plus?", value: "Can you share the details of performance plus?" }
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
